export default class AudioPlayerEventTarget extends EventTarget {
  dispatchProgress(progress: number, duration: number) {
    this.dispatchEvent(new CustomEvent('progress', { detail: { progress, duration } }));
  }
}
